export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Parašykite įrašą...',
  blogsFeedSearchInputPlaceholder: 'Paieška',
  blogsFeedPostOwnerCurtainEditTitle: 'Redaguoti įrašą',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Ištrinti įrašą',
  blogsFeedEditedPostSavedAlertText: 'Įrašas išsaugotas!',
  blogsFeedEditedPostDeletedAlertText: 'Įrašas ištrintas!',
  blogsFeedShareCurtainOptionTitle: 'Kopijuoti nuorodą',
  blogsFeedPostLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Kopijuoti nuorodą',
  blogsFeedOthersPosLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Pažymėti turinį',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Ištrinti įrašą',
  blogsFeedPostDeletePopupTitle: 'Ištrinti',
  blogsFeedPostDeletePopupText: 'Ištrinti šį įrašą?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Atšaukti',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Patvirtinti',
  blogsFeedPostDeeletedAlertText: 'Įrašas ištrintas!',
  blogsPostDetailsHeaderTitle: 'Įrašas',
  postFeedPostLikesText: 'Patinka',
  postFeedPostCommentsText: 'Komentarai',
  postFeedPostNoLikesText: 'Dar nėra „patinka“',
  postFeedPostLeaveFirstLikeText: 'Būkite pirmas, kuriam patinka',
  blogsFeedPostDetailsNoCommentsText: 'Komentarų dar nėra',
  blogsFeedPostDetailsFirstCommentText: 'Palikite pirmą komentarą',
  blogsFeedPostDetailsShareOptionTitle: 'Kopijuoti nuorodą',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Nuoroda nukopijuota!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  blogsFeedPostDetailsCopiedAlertText: 'Nuoroda nukopijuota!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Pažymėti turinį',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Pažymėti',
  blogsPostDetailsReportedCurtainText: 'Turinys pažymėtas',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Redaguoti komentarą',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Ištrinti komentarą',
  blogsPostDetailsEditedCommentSavedAlertText: 'Komentaras išsaugotas!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Ištrinti komentarą',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentaras ištrintas!',
  postDetailsDeleteCommentPopupTitle: 'Ištrinti',
  postDetailsDeleteCommentPopupText: 'Ištrinti šį komentarą?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Atšaukti',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Patvirtinti',
  postDetailsCommDeletedAlertText: 'Komentaras ištrintas!',
  postDetailsCommentUserCurtainOptionTitle: 'Pažymėti komentarą',
  blogsCreatePostCurtainTitle: 'Naujas įrašas',
  blogsCreatePostCurtainBodyPlaceholder: 'Įrašykite tekstą čia...',
  blogsCreatePostPublishButtonTitle: 'Publikuoti',
  blogsCreatePostUploadSlallerImageAlertText: 'Galite įkelti ne daugiau nei {size} MB vienu metu',
  blogsPostSavedAlertText: 'Įrašas išsaugotas!',
  blogsCreatePostAddLocationCurtainTitle: 'Vieta',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Vietos pavadinimas',
  blogsCreatePostEditLocationCurtainText: 'Redaguoti vietą',
  blogsDeleteLocation: 'Ištrinti vietą',
  blogsDiscardPostPopupTitle: 'Juodraštis',
  blogsDiscardPostPopupText: 'Atmesti šį juodraštį?',
  blogsDiscardPostPopupCancelButtonTitle: 'Atšaukti',
  blogsDiscardPostPopupCofirmButtonTitle: 'Patvirtinti',
  blogsNewPostCreatePollTitle: 'Sukurti apklausą',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Pavadinimas',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Parinktis',
  blogsNewPostCreatePollAddButtonTitle: 'Pridėti parinktį',
  blogsNewPostCreatePollCreateButtonTitle: 'Sukurti',
  blogsCreatePostPollTitleBlankAlertText: 'Pavadinimas negali būti tuščias!',
  blogsCreatePostPollOptionBlankAlertText: 'Parinktis negali būti tuščia!',
  blogsCreatePostPollLongTitleAlertText: 'Pavadinimas turi būti ne ilgesnis nei {length} simbolių',
  blogsCreatePostPollLongOptionAlertText: 'Parinktis turi būti ne ilgesnė nei {length} simbolių',
  blogsCreatePostPollEditOptionTitle: 'Redaguoti apklausą',
  blogsCreatePostPollRemoveOptionTitle: 'Pašalinti apklausą',
  blogsPostPollInfoVotesText: 'balsai',
  blogsPostPollInfoEditVoteText: 'Redaguoti balsavimą',
  blogsPostPollFinishPollText: 'Užbaigti apklausą',
  blogsPostPollFinishedPollText: 'Užbaigta',
  blogsPostPollInProgresslText: 'Vyksta',
  blogsFinishPollCurtainTitle: 'Užbaigti apklausą',
  blogsFinishPollCurtainText: 'Po užbaigimo vartotojai nebegalės balsuoti.',
  blogsFinishPollCurtainCancelButtonTitle: 'Atšaukti',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Patvirtinti',
  blogsPollInfoPollVotesCurtainTitle: 'Apklausos balsai',
  blogsEditPostCurtainTitle: 'Redaguoti įrašą',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Įrašykite tekstą čia...',
  blogsEditPostCurtainSaveButtonTitle: 'Išsaugoti',
  blogsEditPostSavedAlertText: 'Įrašas išsaugotas!',
  blogsError: 'Įvyko klaida!',
  blogsAt: 'prie',
  blogsSeeMore: 'Rodyti daugiau...',
  blogsMaxAttachments: 'Viršijote maksimalų priedų skaičių. Maksimalus priedų skaičius yra {length}',
  blogsReply: 'Atsakyti',
  blogsAddCover: 'Pridėti viršelio nuotrauką'
}
